module.exports = __webpack_public_path__ + "static/media/background-one.fd443209.png";